import {
  AudioTrack,
  ConnectionStateToast,
  GridLayout,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer, TrackRefContext,
  useRoomContext,
  useTracks, VideoTrack,
} from '@livekit/components-react';
import EgressHelper from '@livekit/egress-sdk';
import {ConnectionState, Track} from 'livekit-client';
import React, {ReactElement, useCallback, useEffect, useState} from 'react';
// import SingleSpeakerLayout from './SingleSpeakerLayout';
// import SpeakerLayout from './SpeakerLayout';

import './styles.css'
import {lazyRetry} from "../../utils";
import {getTrackReferenceId} from "@livekit/components-core";


// const PanelView501 = React.lazy(() => lazyRetry(() => import("../../screen/501/score-panel"), 'panel_501'));
// const PanelViewScore = React.lazy(() => lazyRetry(() => import("../../screen/score/score-panel"), 'panel_score'));
//
// const FRAME_DECODE_TIMEOUT = 5000;

export default function RoomPage({url, token, layout}) {
  const [error, setError] = useState();
  if (!url || !token) {
    return <div className="error">missing required params url and token</div>;
  }

  return (
    <LiveKitRoom serverUrl={url} token={token} onError={setError}>
      {error ? <div className="error">{error.message}</div> : <CompositeTemplate layout={layout}/>}
    </LiveKitRoom>
  );
}

function RemoteTrack({meta}) {
  const tracks = useTracks([{
      source: Track.Source.Camera,
      withPlaceholder: true
    }, {
      source: Track.Source.Microphone
    }],
    {onlySubscribed: true}
    // { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false },
  );
  const trackRef = tracks.find((trackRef) => {
    return trackRef.participant?.metadata === meta && trackRef.source === Track.Source.Camera
  })
  const audioTrackRef = tracks.find(
    (trackRef) => trackRef.participant?.metadata === meta && trackRef.source === Track.Source.Microphone
  );

  if (!trackRef) return (
    <div className='message'>
      Камера игрока {meta} недоступна
    </div>
  )

  return (<TrackRefContext.Provider
    value={trackRef}
    key={getTrackReferenceId(trackRef)}
  >
    <VideoTrack trackRef={trackRef}/>
    {audioTrackRef && <AudioTrack trackRef={audioTrackRef}/>}
  </TrackRefContext.Provider>)
}

function CompositeTemplate({layout}) {
  const room = useRoomContext();

  EgressHelper.setRoom(room);

  // useEffect(() => {
  //   // determines when to start recording
  //   // the algorithm used is:
  //   // * if there are video tracks published, wait for frames to be decoded
  //   // * if there are no video tracks published, start immediately
  //   // * if it's been more than 10s, record as long as there are tracks subscribed
  //   const startTime = Date.now();
  //   const interval = setInterval(async () => {
  //     let shouldStartRecording = false;
  //     let hasVideoTracks = false;
  //     let hasSubscribedTracks = false;
  //     let hasDecodedFrames = false;
  //     for (const p of Array.from(room.remoteParticipants.values())) {
  //       for (const pub of Array.from(p.trackPublications.values())) {
  //         if (pub.isSubscribed) {
  //           hasSubscribedTracks = true;
  //         }
  //         if (pub.kind === Track.Kind.Video) {
  //           hasVideoTracks = true;
  //           if (pub.videoTrack) {
  //             const stats = await pub.videoTrack.getRTCStatsReport();
  //             if (stats) {
  //               hasDecodedFrames = Array.from(stats).some(
  //                 (item) => item[1].type === 'inbound-rtp' && item[1].framesDecoded > 0,
  //               );
  //             }
  //           }
  //         }
  //       }
  //     }
  //
  //     const timeDelta = Date.now() - startTime;
  //     if (hasDecodedFrames) {
  //       shouldStartRecording = true;
  //     } else if (!hasVideoTracks && hasSubscribedTracks && timeDelta > 500) {
  //       // adding a small timeout to ensure video tracks has a chance to be published
  //       shouldStartRecording = true;
  //     } else if (timeDelta > FRAME_DECODE_TIMEOUT && hasSubscribedTracks) {
  //       shouldStartRecording = true;
  //     }
  //
  //     if (shouldStartRecording) {
  //       EgressHelper.startRecording();
  //       clearInterval(interval);
  //     }
  //   }, 100);
  //   /* eslint-disable-next-line react-hooks/exhaustive-deps */
  // }, []);

  // const tracks = useTracks(
  //   [
  //     {source: Track.Source.Camera, withPlaceholder: true},
  //     {source: Track.Source.Microphone},
  //   ],
  //   {onlySubscribed: false},
  // );
  // const trackRef_1 = tracks.find((trackRef) => {
  //   return trackRef.participant?.metadata === '1' && trackRef.source === Track.Source.Camera
  // })
  // const audioTrackRef_1 = tracks.find((trackRef) => {
  //   return trackRef.participant?.metadata === '1' && trackRef.source === Track.Source.Microphone
  // })
  // const trackRef_2 = tracks.find((trackRef) => {
  //   return trackRef.participant?.metadata === '2' && trackRef.source === Track.Source.Camera
  // })
  // const audioTrackRef_2 = tracks.find((trackRef) => {
  //   return trackRef.participant?.metadata === '2' && trackRef.source === Track.Source.Microphone
  // })

  // determine layout to use
  // let main = <></>;
  // if (room.state !== ConnectionState.Disconnected) {
  //   main = (
  //     <>
  //       <div>
  //         {trackRef_1 && <VideoTrack trackRef={trackRef_1}/>}
  //       </div>
  //       <div>
  //         {trackRef_2 && <VideoTrack trackRef={trackRef_2}/>}
  //       </div>
  //
  //
  //       {/*<VideoTrack trackRef={trackRef_2}/>*/}
  //       {/*<TrackRefContext.Provider*/}
  //       {/*  value={trackRef_1}*/}
  //       {/*  key={getTrackReferenceId(trackRef_1)}*/}
  //       {/*>*/}
  //       {/*</TrackRefContext.Provider>*/}
  //       {/*<TrackRefContext.Provider*/}
  //       {/*  value={trackRef_2}*/}
  //       {/*  key={getTrackReferenceId(trackRef_2)}*/}
  //       {/*>*/}
  //
  //       {/*</TrackRefContext.Provider>*/}
  //     </>
  //   );
  // }

  const handlerClick = useCallback((e) => {
    const container = e.currentTarget
    if (container.requestFullscreen) {
      container.requestFullscreen();
    } else if (container.webkitRequestFullscreen) { // Safari
      container.webkitRequestFullscreen();
    } else if (container.msRequestFullscreen) { // IE/Edge
      container.msRequestFullscreen();
    }
  })

  return (
    <>
      <div className='room-container' onClick={handlerClick}>
        <div className="camera-video">
          <RemoteTrack meta='1'/>
        </div>
        <div className="camera-video">
          <RemoteTrack meta='2'/>
        </div>
        {/*<div className='room-panel'>*/}
        {/*  {(INIT_DATA.type_game == '501' || INIT_DATA.type_game == '301') && (*/}
        {/*    <PanelView501/>*/}
        {/*  )}*/}
        {/*  {(INIT_DATA.type_game == 'score') && (*/}
        {/*    <PanelViewScore/>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
      <ConnectionStateToast/>
    </>
  );
}